import React, {Component} from "react";
import {Col, ControlLabel, Form, FormGroup, Row} from "react-bootstrap";
import {TopSelect} from "../../../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import EPrzystankiService from "../../../../../trasyConfig/ePrzystanki/EPrzystankiService";
import DateAndTimeUtilities from "../../../../../../../utilities/DateAndTimeFormat";
import ClientService from "../../../../biletyApi/ClientService";
import moment from "moment";
import {TopInputDate} from "../../../../../../../componentsTopsa/inputs/TopInputs";
import {TopAlertOstrzezenie} from "../../../../../../../componentsTopsa/alerty/TopAlerts";
import {TopButtonAction} from "../../../../../../../componentsTopsa/buttons/TopButtons";
import PasazerInput from "./components/PasazerInput";
import ZnizkaSelect from "./components/ZnizkaSelect";
import TopIf from "../../../../../../../componentsTopsa/if/TopIf";

export default class DefiniowanieZamowieniaSekcja extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            status: null,
            forma: null,
            data: moment(),
            godzinaOd: {value: '05:00', label: '05:00'},
            kurs: null,
            kursy: [],
            eprzystanki: [],
            eprzystankiOd: [],
            eprzystankiDo: [],
            przystanekOd: null,
            przystanekDo: null,
            znizki: [],

            godzinaOdjazdu: null,

            pasazerowieIndeks: 2,
            pasazerowieIndeksPowrotny: 2,
            pasazerowie: [
                {
                    id: 'pasazer-1',
                    pasazer: '',
                    pasazerImie:'',
                    pasazerNazwisko:'',
                    rodz: 'NZ',
                    idPro: null,
                }
            ],
            pasazerowiePowrotny: [
                {
                    id: 'pasazer-powrotny-1',
                    pasazer: '',
                    pasazerImie:'',
                    pasazerNazwisko:'',
                    rodz: 'NZ',
                    idPro: null,
                }
            ],
            czyZablokowacInputPasazer: true,

        }

        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onChangeForma = this.onChangeForma.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeGodzinaOd = this.onChangeGodzinaOd.bind(this)
        this.onChangePrzystanekOd = this.onChangePrzystanekOd.bind(this)
        this.onChangePrzystanekDo = this.onChangePrzystanekDo.bind(this)
        this.onChangeKurs = this.onChangeKurs.bind(this)

        this.wyslijDaneKursuDoRodzica = this.wyslijDaneKursuDoRodzica.bind(this)

        this.dodajNowegoPasazera = this.dodajNowegoPasazera.bind(this)
        this.usunPasazera = this.usunPasazera.bind(this)
        this.onChangePasazer = this.onChangePasazer.bind(this)
        this.onChangePasazerImie = this.onChangePasazerImie.bind(this)
        this.onChangePasazerNazwisko = this.onChangePasazerNazwisko.bind(this)
        this.onChangeZnizka = this.onChangeZnizka.bind(this)
        this.ustawNazwePierwszegoPasazeraZgodnieZZamawiajacym = this.ustawNazwePierwszegoPasazeraZgodnieZZamawiajacym.bind(this)

    }

    componentDidMount() {

        if (this.props.typ === 'podstawowy') {
            this.setState({
                status: this.props.statusy[0],
            })
        }
        if (this.props.typ === 'powrotny') {
            // ustawienie trasy powrotnej
            if (this.props.daneKursPodstawowy) {
                this.przygotujPodKursPowrotny(this.props.daneKursPodstawowy)
            }
            // skopiowanie pasazerow
            if (this.state.pasazerowie.length === 1) {
                let arr = [];
                let index = 1;

                for (let i = 0; i < this.props.pasazerowiePodstawowy.length; i++) {
                    arr.push({
                        id: 'pasazer-powrotny-' + (i + 1),
                        pasazer: this.props.pasazerowiePodstawowy[i].pasazer,
                        pasazerImie:this.props.pasazerowiePodstawowy[i].pasazerImie,
                        pasazerNazwisko:this.props.pasazerowiePodstawowy[i].pasazerNazwisko,
                        rodz: this.props.pasazerowiePodstawowy[i].rodz,
                        idPro: null,
                    })
                    index = i + 1;
                }

                this.setState({
                    pasazerowiePowrotny: arr,
                    pasazerowieIndeksPowrotny: (index + 1)
                })
            }
        }
    }

    componentWillReceiveProps(nextprops) {
        if (this.props.typ === 'powrotny') {
            if (nextprops.daneKursPodstawowy) {
                this.przygotujPodKursPowrotny(nextprops.daneKursPodstawowy)
            }
        }

        if (this.props.typ === 'podstawowy') {
            // ustawienie pierwszego pasazera
            let zablokujInputPasazer = true;
            if (Boolean(nextprops.zamawiajacyKlient)) {
             //   if (nextprops.zamawiajacyKlient.zamawiajacyNazwisko.length > 0 || nextprops.zamawiajacyKlient.zamawiajacyImie.length > 0) {
                    zablokujInputPasazer = false;
                    this.ustawNazwePierwszegoPasazeraZgodnieZZamawiajacym(nextprops.zamawiajacyKlient)
             //   }
            }
            this.setState({czyZablokowacInputPasazer: zablokujInputPasazer})
        }
    }

    // ############# KURS #############

    przygotujPodKursPowrotny(kursPodstawowy) {
        if (Boolean(kursPodstawowy) && !Boolean(this.state.trasa)) {
            let trasa = this.props.trasy.find(t => t.idTr === kursPodstawowy.idTr)
            if (Boolean(trasa)) {
                let trasaOdwrotna = this.props.trasy.find(t => t.nazMiOd === trasa.nazMiDo && t.nazMiDo === trasa.nazMiOd)
                if (Boolean(trasaOdwrotna)) {
                    this.setState({trasa: trasaOdwrotna})
                    this.pobierzEPrzystankiNaTrasie(trasaOdwrotna, kursPodstawowy)
                }
            }
        }
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
        if (e !== null) {
            this.pobierzEPrzystankiNaTrasie(e)
        }
    }

    onChangeStatus(e) {
        this.setState({status: e})
        this.wyslijDaneKursuDoRodzica('statBil', e)
        if (e.value === 1) {
            this.setState({forma: this.props.formyPlatnosci[0]})
        }
        else {
            this.setState({forma: null})
        }
    }

    onChangeForma(e) {
        this.setState({forma: e})
        if (e !== null)
            this.wyslijDaneKursuDoRodzica('formaPlatn', e)
    }

    onChangeData(e) {
        this.setState({data: e, godzinaOd:{value: '00:00', label: '00:00'}})
        if (
            Boolean(this.state.przystanekOd) &&
            Boolean(this.state.przystanekDo) &&
            e !== null
        ) {
            this.pobierzKursy(this.state.przystanekOd, this.state.przystanekDo, e, {value: '00:00', label: '00:00'})
        }
    }

    onChangeGodzinaOd(e) {
        this.setState({godzinaOd: e})
        if (
            Boolean(this.state.przystanekOd) &&
            Boolean(this.state.przystanekDo) &&
            Boolean(this.state.data) &&
            e !== null
        ) {
            this.pobierzKursy(this.state.przystanekOd, this.state.przystanekDo, this.state.data, e)
        }
    }

    onChangePrzystanekOd(e) {
        this.setState({przystanekOd: e})
        if (e !== null) {
            let eprzystanki = this.state.eprzystanki.find(i => i.przystanekOd.idPr === e.idPr)
            if (Boolean(eprzystanki)) {
                let przystankiDo = Array.from(eprzystanki.przystanki, item => {
                    return {
                        ...item,
                        info: item.nazMi + ' ' + item.nazPr
                    }
                })
                this.setState({eprzystankiDo: przystankiDo})

                let przystanekDo = null;
                if (Boolean(przystankiDo.find(p => p.domyslny == 1))) {
                    przystanekDo = przystankiDo.find(p => p.domyslny == 1)
                } else {
                    przystanekDo = przystankiDo[0]
                }

                this.setState({przystanekDo: przystanekDo})
                this.pobierzKursy(e, przystanekDo, this.state.data, this.state.godzinaOd)
            }
        }
    }

    onChangePrzystanekDo(e) {
        this.setState({przystanekDo: e})
        if (
            Boolean(this.state.przystanekOd) &&
            Boolean(this.state.data) &&
            e !== null
        ) {
            this.pobierzKursy(this.state.przystanekOd, e, this.state.data, this.state.godzinaOd)
        }
    }

    onChangeKurs(e) {
        this.setState({kurs: e})
        if (e !== null) {
            this.setState({godzinaOdjazdu: e.godz})
            this.pobierzZnizki(e, this.state.przystanekOd, this.state.przystanekDo)
        }
    }

    pobierzEPrzystankiNaTrasie(trasa, kursPodstawowy) {
        EPrzystankiService.getEprzystankiPoTrasie(trasa.idTr).then(function (response) {
            if (response.status < 300) {
                let eprzystankiOd = Array.from(response.data, item => {
                    return Object.assign(item.przystanekOd, {info: item.przystanekOd.nazMi + ' ' + item.przystanekOd.nazPr})
                })
                this.setState({eprzystanki: response.data, eprzystankiOd: eprzystankiOd})
                this.ustawPrzystanekPoczatkowy(trasa, response.data, eprzystankiOd, kursPodstawowy)
            }
        }.bind(this))
    }

    ustawPrzystanekPoczatkowy(trasa, eprzystanki, eprzystankiOd, kursPodstawowy) {
        let przystanek = null;

        if (eprzystankiOd.length === 1) {
            przystanek = eprzystankiOd[0]
        }
        else {
            let pom = eprzystankiOd.find(p => p.nazMi === trasa.nazMiOd)
            if (Boolean(pom)) {
                przystanek = pom
            }
            else {
                przystanek = eprzystankiOd[0]
            }
        }

        if (Boolean(przystanek)) {
            this.setState({przystanekOd: przystanek});
            this.ustawPrzystanekKoncowy(trasa, eprzystanki, przystanek, kursPodstawowy)
        }
    }

    ustawPrzystanekKoncowy(trasa, eprzystanki, przystanekOd, kursPodstawowy) {
        let rekord = eprzystanki.find(obj => obj.przystanekOd.idPr === przystanekOd.idPr)

        if (Boolean(rekord)) {

            let przystankiDo = Array.from(rekord.przystanki, item => {
                return {
                    ...item,
                    info: item.nazMi + ' ' + item.nazPr
                }
            })

            if (przystankiDo.length > 0) {
                let przystanekDo = null;
                if (Boolean(przystankiDo.find(p => p.domyslny == 1))) {
                    przystanekDo = przystankiDo.find(p => p.domyslny == 1)
                }
                else {
                    przystanekDo = przystankiDo[0]
                }

                this.setState({eprzystankiDo: przystankiDo, przystanekDo: przystanekDo})


                if (Boolean(kursPodstawowy)) {
                    // gdy jest to kurs powrotny i wiemy o kursie podstawowym - trzeba dobrac date o godzine

                    let godzina = null

                    // szukamy godziny o 3godz pozniejszej

                    //    let pom = Boolean(kursPodstawowy.idKu)?parseInt(kursPodstawowy.godzinaOdjazdu.replace(':', '.')) + 3 : 0
                    let pom = parseInt(kursPodstawowy.godzinaOdjazdu.replace(':', '.')) + 3

                    if (pom >= 24) {
                        // selekt na nastepny dzień
                        pom = "00:00"

                        godzina = this.props.godzinyOd.find(g => g.value == pom)

                        if (Boolean(godzina)) {
                            this.setState({
                                godzinaOd: godzina,
                                data: moment(kursPodstawowy.data).add('days', 1)
                            })
                            this.pobierzKursy(przystanekOd, przystanekDo, moment(kursPodstawowy.data).add('days', 1), godzina)
                        }
                    }
                    else {
                        // ten sam dzień, pozniejsza godzina
                        pom = pom + ':00'
                        godzina = this.props.godzinyOd.find(g => g.value == pom)

                        if (Boolean(godzina)) {
                            this.setState({
                                godzinaOd: godzina,
                                data: moment(kursPodstawowy.data)
                            })
                            this.pobierzKursy(przystanekOd, przystanekDo, moment(kursPodstawowy.data), godzina)
                        }
                    }

                } else {
                    this.pobierzKursy(przystanekOd, przystanekDo, this.state.data, this.state.godzinaOd)

                }
            }
        }
    }

    pobierzKursy(pod, pdo, data, godz) {
        let obj = {
            "data": DateAndTimeUtilities.formatYYYYMMDD(data),
            "godz": Boolean(godz) ? godz.value : null,
            "idPrDo": pdo.idPr,
            "idPrOd": pod.idPr
        }
        ClientService.getKursyMiedzyPrzystankamiWDanymCzasie(obj).then(function (response) {
            if (response.status < 300) {

                if (response.data.length === 0) {
                    // nie ma kursów
                    this.wyslijDaneKursuDoRodzica('idKu', null)
                    this.setState({kursy: [], kurs: null})
                }
                else {
                    this.setState({kursy: response.data, kurs: response.data[0], godzinaOdjazdu: response.data[0].godz})
                    this.pobierzZnizki(response.data[0], pod, pdo)
                }

            }
        }.bind(this))
    }

    pobierzZnizki(kurs, pod, pdo) {
        let obj = {
            "idKu": kurs.idKu,
            "idMiDo": pdo.idMi,
            "idMiOd": pod.idMi
        }
        ClientService.getZnizkiNaDanymOdcinku(obj).then(function (response) {

            console.log(response.data)

            if (response.status < 300) {
                this.setState({znizki: response.data})
                if (response.data.length > 0)
                    this.ustawPromocjeJesliIstniejeBadzUsun(response.data)
                this.wyslijDaneKursuDoRodzica('znizki', response.data)
            }
        }.bind(this))
    }


    renderTrasyOption(option) {
        return (
            <div>{option.nazTr}
                <TopDostepnosc wartoscWarunek={0} wartosc={option.status} czyMarginesLewy={true}/>
            </div>
        )
    }

    renderKursyOption(option) {
        return <div style={(option.czyZablok === 0) ? {} : {
            cursor: (option.czyZablok === 2) ?'not-allowed':'help',
        }}>
            <span style={{marginRight: '15px'}}
                  title={'Numer kursu'}>
                <span className={'label label-ebus-primary'}>{option.idKu}</span>
            </span>
            <span style={{marginRight: '10px', fontWeight: 'bold'}}>
                {option.nazMiOd} <i className={'fa fa-long-arrow-right'}></i> {option.nazMiDo}
            </span>
            <span style={{fontWeight: 'bold'}}>
                Odjazd o <span className={'label label-ebus-secondary'} style={{marginLeft: '3px'}}>{option.godz}</span>
            </span>
            <span style={{margin: '0 6px', fontSize:'10px', fontStyle:'italic', color: 'grey'}}>
                Przyjazd o {option.godzPrzy}
            </span>
            {
                (option.czyZablok === 0) ?
                    <div className={'pull-right'} style={{marginRight: '12px'}}>
                        {
                            (option.ileWoln !== null) ?
                                <span>
                            <TopIf isTrue={option.ileWoln === 0}><span title={'Są miejsca siedzące'} style={{color: 'forestgreen'}}><i
                                className={'fa fa-user-plus'}></i></span></TopIf>
                            <TopIf isTrue={option.ileWoln === 1}><span title={'Są miejsca stojące'} style={{color: 'darkorange'}}><i
                                className={'fa fa-male'}></i></span></TopIf>
                            <TopIf isTrue={option.ileWoln === 2}><span title={'Brak miejsc'} style={{color: 'firebrick'}}><i
                                className={'fa fa-user-times'}></i></span></TopIf>
                        </span>
                                :
                                <span title={'Brak danych dotyczących miejsc'} style={{color: '#ccc'}}><i
                                    className={'fa fa-question-circle'}></i></span>
                        }
                    </div>
                    :
                    <div className={'pull-right'} style={{marginRight: '12px'}}>
                        <span style={(option.czyZablok === 2) ? {color: 'firebrick'} : {color: 'darkorange'}}><i
                            className={(option.czyZablok === 2) ? 'fa fa-times-circle-o' : 'fa fa-question-circle-o'}></i></span>
                    </div>
            }

        </div>
    }

    renderEprzystanki(option) {
        return (<div style={Boolean(option.domyslny) ? {fontWeight: 'bold'} : {}}>
            <span className={'label label-ebus-primary'}>{option.nazMi}</span>
            <span style={{marginLeft: '3px'}}>{option.nazPr}</span>
        </div>)
    }

    wyslijDaneKursuDoRodzica(key, value) {
        if (Boolean(this.state.trasa)) {
            let obj = {
                data: DateAndTimeUtilities.formatYYYYMMDD(this.state.data),
                godzina: this.state.godzinaOd,

                godzinaOdjazdu: Boolean(this.state.kurs) ? this.state.godzinaOdjazdu : null,

                idTr: this.state.trasa.idTr,
                idPrOd: this.state.przystanekOd.idPr,
                idPrDo: this.state.przystanekDo.idPr,
                idKu: Boolean(this.state.kurs) ? this.state.kurs.idKu : null,

                statBil: Boolean(this.state.status) ? this.state.status.value : null,
                formaPlatn: Boolean(this.state.forma) ? this.state.forma.formaPlatn : null,
                znizki: this.state.znizki,
                czyZablok: Boolean(this.state.kurs) ? this.state.kurs.czyZablok : null,
                uwagiKurs: Boolean(this.state.kurs) ? this.state.kurs.uwagi : null
            }
            if (key === 'statBil') {
                obj[key] = value.value
                if (value.value === 1) {
                    obj['formaPlatn'] = 'GK'
                } else {
                    obj['formaPlatn'] = null
                }
            }
            else if (key === 'formaPlatn') {
                obj[key] = value.formaPlatn
                obj['statBil'] = 1
            }
            else {
                obj[key] = value;
            }
            this.props.handleDaneKursu(obj, this.props.typ)
        }
    }


// ############# PASAZEROWIE #############


    /* modyfikatory wielkosci tablicy pasazerowie */

    dodajNowegoPasazera() {
        let arr;

        if (this.props.typ === 'podstawowy') {
            arr = this.state.pasazerowie
        }
        else {
            arr = this.state.pasazerowiePowrotny
        }

        let promocja = null;
        if (this.state.znizki.length > 0) {
            if (this.state.znizki.find(z => z.rodz === 'NZ')) {
                promocja = (this.state.znizki.find(z => z.rodz === 'NZ')).idPro
            }
        }

        arr.push({
            id: (this.props.typ === 'podstawowy') ? 'pasazer-' + this.state.pasazerowieIndeks : 'pasazer-powrotny-' + this.state.pasazerowieIndeksPowrotny,
            pasazer: arr[0].pasazer,    //kopiowanie wartosci z pierwszego pasazera
            pasazerImie: arr[0].pasazerImie,    //kopiowanie wartosci z pierwszego pasazera
            pasazerNazwisko: arr[0].pasazerNazwisko,    //kopiowanie wartosci z pierwszego pasazera
            rodz: 'NZ',
            idPro: promocja,
        })

        if (this.props.typ === 'podstawowy') {
            this.setState({
                pasazerowieIndeks: this.state.pasazerowieIndeks + 1,
                pasazerowie: arr
            })
        }
        else {
            this.setState({
                pasazerowieIndeksPowrotny: this.state.pasazerowieIndeks + 1,
                pasazerowiePowrotny: arr
            })
        }


        this.props.wyslijTablicePasazerowWyzej(arr)
    }

    usunPasazera(id) {
        let arr;

        if (this.props.typ === 'podstawowy') {
            arr = this.state.pasazerowie
        }
        else {
            arr = this.state.pasazerowiePowrotny
        }

        arr.splice(arr.findIndex(i => i.id == id), 1);

        if (this.props.typ === 'podstawowy') {
            this.setState({
                pasazerowie: arr
            })
        }
        else {
            this.setState({
                pasazerowiePowrotny: arr
            })
        }
        this.props.wyslijTablicePasazerowWyzej(arr)
    }

    /* modyfikatory wartosci itemu tablicy pasazerowie */

    ustawNazwePierwszegoPasazeraZgodnieZZamawiajacym(obj) {
        // tylko gdy sekcja bilet podstawowy
        if (this.state.pasazerowie[0].pasazerNazwisko !== obj.zamawiajacyNazwisko || this.state.pasazerowie[0].pasazerImie !== obj.zamawiajacyImie) {
            let arr = this.state.pasazerowie
            let pasazer = arr[0]
            pasazer['pasazerImie'] = obj.zamawiajacyImie;
            pasazer['pasazerNazwisko'] = obj.zamawiajacyNazwisko;
            this.setState({pasazerowie: arr})
            this.props.wyslijTablicePasazerowWyzej(arr)
        }
    }

    ustawPromocjeJesliIstniejeBadzUsun(znizki) {
        // jeśli istnieje jakaś promocja, wszystkie pozycje w pasazerach  z rodz NZ maja zmieniana idPro z null na id
        // jeśli nie istnieje, promocje idPro sa kasowane
        let znizka = znizki.find(z => z.rodz === 'NZ')
        if (Boolean(znizka)) {
            if (Boolean(znizka.idPro)) {

                let arr;

                if (this.props.typ === 'podstawowy') {
                    arr = this.state.pasazerowie
                }
                else {
                    arr = this.state.pasazerowiePowrotny
                }

                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].rodz === 'NZ')
                        arr[i].idPro = znizka.idPro
                }
                if (this.props.typ === 'podstawowy') {
                    this.setState({
                        pasazerowie: arr
                    })
                }
                else {
                    this.setState({
                        pasazerowiePowrotny: arr
                    })
                }
                this.props.wyslijTablicePasazerowWyzej(arr)

            }
            else {
                let arr;

                if (this.props.typ === 'podstawowy') {
                    arr = this.state.pasazerowie
                }
                else {
                    arr = this.state.pasazerowiePowrotny
                }

                for (let i = 0; i < arr.length; i++) {
                    arr[i].idPro = null
                }

                if (this.props.typ === 'podstawowy') {
                    this.setState({
                        pasazerowie: arr
                    })
                }
                else {
                    this.setState({
                        pasazerowiePowrotny: arr
                    })
                }
                this.props.wyslijTablicePasazerowWyzej(arr)
            }
        }
    }

    onChangePasazer(obj, value) {
        let arr;

        if (this.props.typ === 'podstawowy') {
            arr = this.state.pasazerowie
        }
        else {
            arr = this.state.pasazerowiePowrotny
        }
        let pasazer = arr.find(p => p.id === obj.id)
        pasazer['pasazer'] = value;
        if (this.props.typ === 'podstawowy') {
            this.setState({
                pasazerowie: arr
            })
        }
        else {
            this.setState({
                pasazerowiePowrotny: arr
            })
        }
        this.props.wyslijTablicePasazerowWyzej(arr)
    }

    onChangePasazerImie(obj, value) {
        let arr;

        if (this.props.typ === 'podstawowy') {
            arr = this.state.pasazerowie
        }
        else {
            arr = this.state.pasazerowiePowrotny
        }
        let pasazer = arr.find(p => p.id === obj.id)
        pasazer['pasazerImie'] = value;
        if (this.props.typ === 'podstawowy') {
            this.setState({
                pasazerowie: arr
            })
        }
        else {
            this.setState({
                pasazerowiePowrotny: arr
            })
        }
        this.props.wyslijTablicePasazerowWyzej(arr)
    }

    onChangePasazerNazwisko(obj, value) {
        let arr;

        if (this.props.typ === 'podstawowy') {
            arr = this.state.pasazerowie
        }
        else {
            arr = this.state.pasazerowiePowrotny
        }
        let pasazer = arr.find(p => p.id === obj.id)
        pasazer['pasazerNazwisko'] = value;
        if (this.props.typ === 'podstawowy') {
            this.setState({
                pasazerowie: arr
            })
        }
        else {
            this.setState({
                pasazerowiePowrotny: arr
            })
        }
        this.props.wyslijTablicePasazerowWyzej(arr)
    }

    onChangeZnizka(obj, value, idPro) {
        let arr;

        if (this.props.typ === 'podstawowy') {
            arr = this.state.pasazerowie
        }
        else {
            arr = this.state.pasazerowiePowrotny
        }
        let pasazer = arr.find(p => p.id === obj.id)
        pasazer['rodz'] = value;
        pasazer['idPro'] = idPro;   // jesli jest promocja, doda numer promocji
        if (this.props.typ === 'podstawowy') {
            this.setState({
                pasazerowie: arr
            })
        }
        else {
            this.setState({
                pasazerowiePowrotny: arr
            })
        }
        this.props.wyslijTablicePasazerowWyzej(arr)
    }


    renderStatusBiletu(option) {
        return <div style={{fontWeight: 'bold', color: option.kolor}}><i className={option.ikona} style={{marginRight: '5px'}}></i> {option.label}
        </div>
    }

    render() {
        return (
            <div style={{marginTop: '15px'}}>
                <fieldset>
                    <div className={'fieldset-label'}>
                        {Boolean(this.props.typ) ? 'Bilet ' + this.props.typ : ''}
                    </div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12}>
                                <Row>
                                    <Col xs={12} lg={4}>
                                        <ControlLabel>Trasa</ControlLabel>
                                        <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy}
                                                   valueKey={'idTr'} labelKey={'nazTr'}
                                                   valueRenderer={this.renderTrasyOption} optionRenderer={this.renderTrasyOption} clearable={false}
                                        />
                                    </Col>
                                    <Col xs={12} lg={3}>
                                        <TopIf isTrue={this.props.typ === 'podstawowy'}>
                                            <Row>
                                                <Col xs={6}>
                                                    <ControlLabel>Status</ControlLabel>
                                                    <TopSelect onChange={this.onChangeStatus}
                                                               value={this.state.status}
                                                               options={this.props.statusy}
                                                               clearable={false}
                                                               valueRenderer={this.renderStatusBiletu} optionRenderer={this.renderStatusBiletu}
                                                    />
                                                </Col>
                                                <Col xs={6}>
                                                    <ControlLabel>Forma płatności</ControlLabel>
                                                    <TopSelect onChange={this.onChangeForma}
                                                               value={this.state.forma}
                                                               options={this.props.formyPlatnosci}
                                                               clearable={false}
                                                               valueKey={'formaPlatn'}
                                                               labelKey={'nazwa'}
                                                               disabled={Boolean(this.state.status) ? this.state.status.value !== 1 : true}
                                                    />
                                                </Col>
                                            </Row>
                                        </TopIf>
                                    </Col>
                                    <Col xs={12} lg={2}>
                                        <ControlLabel>Data</ControlLabel>
                                        <TopInputDate onChange={this.onChangeData} value={this.state.data} horizontal={true}
                                                      minDate={moment()}
                                        />
                                    </Col>
                                    <Col xs={12} lg={2}>
                                        <ControlLabel>Od godziny</ControlLabel>
                                        <TopSelect onChange={this.onChangeGodzinaOd} value={this.state.godzinaOd} options={this.props.godzinyOd}
                                                   clearable={false}/>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={7}>
                                        <Row>
                                            <Col xs={12} lg={6}>
                                                <ControlLabel>Od przystanku</ControlLabel>
                                                <TopSelect onChange={this.onChangePrzystanekOd}
                                                           value={this.state.przystanekOd}
                                                           options={this.state.eprzystankiOd}
                                                           valueKey={'idPr'} labelKey={'info'}
                                                           valueRenderer={this.renderEprzystanki} optionRenderer={this.renderEprzystanki}
                                                           clearable={false} disabled={!Boolean(this.state.trasa)}
                                                />
                                            </Col>
                                            <Col xs={12} lg={6}>
                                                <ControlLabel>Do przystanku</ControlLabel>
                                                <TopSelect onChange={this.onChangePrzystanekDo}
                                                           value={this.state.przystanekDo}
                                                           options={this.state.eprzystankiDo}
                                                           valueKey={'idPr'} labelKey={'info'}
                                                           valueRenderer={this.renderEprzystanki} optionRenderer={this.renderEprzystanki}
                                                           clearable={false} disabled={!Boolean(this.state.przystanekOd)}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <ControlLabel>Kurs</ControlLabel>
                                        {
                                            Boolean(this.state.kurs) ?
                                                <span style={{marginLeft: '10px', fontSize: '12px'}}>
                                                            {
                                                                (this.state.kurs.czyZablok === 0) ?
                                                                    (this.state.kurs.ileWoln !== null) ?
                                                                        <span>
                                                                        <TopIf isTrue={this.state.kurs.ileWoln === 0}><span
                                                                            style={{color: 'forestgreen'}}><i className={'fa fa-user-plus'}></i> W busie są miejsca siedzące</span></TopIf>
                                                                        <TopIf isTrue={this.state.kurs.ileWoln === 1}><span
                                                                            style={{color: 'darkorange'}}><i className={'fa fa-male'}></i> W busie pozostały miejsca stojące</span></TopIf>
                                                                        <TopIf isTrue={this.state.kurs.ileWoln === 2}><span
                                                                            style={{color: 'firebrick'}}><i className={'fa fa-user-times'}> Brak miejsc w busie</i></span></TopIf>
                                                                    </span>
                                                                        :
                                                                        <span style={{color: '#aaa'}}><i className={'fa fa-question-circle'}></i> Brak informacji o miejscach w busie</span>
                                                                    :
                                                                    <span
                                                                        style={(this.state.kurs.czyZablok === 2) ? {color: 'firebrick'} : {color: 'darkorange'}}>
                                                                        {
                                                                            (this.state.kurs.czyZablok === 2) ?
                                                                                <span><i className={'fa fa-times-circle-o'}></i> Brak możliwości wyboru - {this.state.kurs.uwagi}</span>
                                                                            :
                                                                                <span><i className={'fa fa-question-circle-o'}></i> Niezalecany wybór - {this.state.kurs.uwagi}</span>
                                                                        }
                                                                    </span>
                                                            }
                                                        </span>
                                                :
                                                ''
                                        }
                                        <TopSelect onChange={this.onChangeKurs}
                                                   value={this.state.kurs}
                                                   options={this.state.kursy}
                                                   valueKey={'idKu'} labelKey={'idKu'}
                                                   valueRenderer={this.renderKursyOption}
                                                   optionRenderer={this.renderKursyOption}
                                                   disabled={!Boolean(this.state.trasa)} clearable={false}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <Row>
                                    <Col xs={12} lg={6}>
                                        <TopIf isTrue={this.props.typ === 'podstawowy' && this.state.czyZablokowacInputPasazer}>
                                            <div style={{marginLeft: '30px', marginTop: '5px'}}>
                                                <TopAlertOstrzezenie
                                                    text={'Lista pasażerów zablokowana. Proszę uzupełnić w powyższej sekcji szczegóły klienta, który zamawia bilet.'}/>
                                            </div>
                                        </TopIf>
                                    </Col>
                                </Row>
                                <Row>

                                    <Col xs={12} lg={8}>
                                        <Row style={{fontWeight: 'bold'}}>
                                            <Col xs={1} style={{textAlign: 'right'}}>
                                                Lp.
                                            </Col>
                                            <Col xs={2}>
                                                Imie
                                            </Col>
                                            <Col xs={3}>
                                                Nazwisko
                                            </Col>
                                            <Col xs={5}>
                                                Cena biletu
                                            </Col>
                                            <Col xs={1}>
                                                Usuń
                                            </Col>
                                        </Row>
                                        {
                                            (this.props.typ === 'podstawowy') ?
                                                <div>
                                                    {
                                                        this.state.pasazerowie.map((item, index) => {
                                                            return (<Row style={{marginTop: '5px'}} key={'row-' + item.id}>
                                                                <Col xs={1} style={{textAlign: 'right'}}>
                                                                    <div style={{lineHeight: '34px'}}>#{index + 1}</div>
                                                                </Col>
                                                                <Col xs={5}>
                                                                    <PasazerInput item={item}
                                                                                  handleChangeInputImie={this.onChangePasazerImie}
                                                                                  handleChangeInputNazwisko={this.onChangePasazerNazwisko}
                                                                                  disabled={(this.state.czyZablokowacInputPasazer) || index === 0}/>
                                                                </Col>
                                                                <Col xs={5}>
                                                                    <ZnizkaSelect item={item} rodz={item.rodz} znizki={this.state.znizki}
                                                                                  hangleChangeSelect={this.onChangeZnizka}/>
                                                                </Col>
                                                                <Col xs={1}>
                                                                    <TopIf isTrue={index !== 0}>
                                                                        <div style={{
                                                                            textAlign: 'center',
                                                                            color: 'firebrick',
                                                                            cursor: 'pointer',
                                                                            lineHeight: '34px'
                                                                        }}
                                                                             onClick={() => this.usunPasazera(item.id)}
                                                                        >
                                                                            <i className={'fa fa-times'}></i>
                                                                        </div>
                                                                    </TopIf>
                                                                </Col>
                                                            </Row>)
                                                        })
                                                    }
                                                </div>
                                                :
                                                <div>
                                                    {
                                                        this.state.pasazerowiePowrotny.map((item, index) => {
                                                            return (<Row style={{marginTop: '5px'}} key={'row-' + item.id}>
                                                                <Col xs={1} style={{textAlign: 'right'}}>
                                                                    <div style={{lineHeight: '34px'}}>#{index + 1}</div>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <PasazerInput item={item} handleChangeInput={this.onChangePasazer}
                                                                                  disabled={false}/>
                                                                </Col>
                                                                <Col xs={6}>
                                                                    <ZnizkaSelect item={item} rodz={item.rodz} znizki={this.state.znizki}
                                                                                  hangleChangeSelect={this.onChangeZnizka}/>
                                                                </Col>
                                                                <Col xs={1}>
                                                                    <TopIf isTrue={index !== 0}>
                                                                        <div style={{
                                                                            textAlign: 'center',
                                                                            color: 'firebrick',
                                                                            cursor: 'pointer',
                                                                            lineHeight: '34px'
                                                                        }}
                                                                             onClick={() => this.usunPasazera(item.id)}
                                                                        >
                                                                            <i className={'fa fa-times'}></i>
                                                                        </div>
                                                                    </TopIf>
                                                                </Col>
                                                            </Row>)
                                                        })
                                                    }
                                                </div>
                                        }

                                    </Col>
                                </Row>
                                <div>
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <div className={'pull-right'} style={{marginTop: '15px'}}>
                                                <TopButtonAction text={'Dodaj nowego pasażera'}
                                                                 btnColor={'success'}
                                                                 iconType={'fa fa-user-plus'}
                                                                 btnSize={'small'}
                                                                 onClick={this.dodajNowegoPasazera}
                                                                 btnDisabled={this.props.typ === 'podstawowy' && this.state.czyZablokowacInputPasazer}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/dodajBiletJednorazowy/components/definiowanieZamowienia/sekcja/DefiniowanieZamowieniaSekcja.js